import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

const StyledBox = styled(Box)(() => ({
  position: 'absolute',
  top: '0',
  left: '0',
  bottom: 'auto',
  right: 'auto',
  width: '100%',
  zIndex: 1,
}));

const Shape = React.memo(function Shape({ type }) {
  switch (type) {
    case 'triangle-left-slant-up':
      return <polygon points="0,0 100,0 0,100" />;
    case 'triangle-right-slant-up':
      return <polygon points="100,0 100,100 0,100" />;
    case 'triangle-left-slant-down':
      return <polygon points="0,0 100,100 0,100" />;
    case 'triangle-right-slant-down':
      return <polygon points="100,0 100,100 0,0" />;
    case 'curve':
      return <path d="M0,0 L100,0 Q50,100 0,0 Z" />;
    default:
      return <rect x="0" y="0" width="100" height="100" />;
  }
});

Shape.propTypes = {
  type: PropTypes.oneOf([
    'triangle-left-slant-up',
    'triangle-right-slant-up',
    'triangle-left-slant-down',
    'triangle-right-slant-down',
    'curve'
  ]),
};

Shape.defaultProps = {
  type: 'triangle-left-slant-up',
};

const Separator = ({
  fill = 'brand',
  height = '20px',
  position = 'top',
  type = 'triangle-left-slant-up',
}) => {
  // const theme = useTheme();
  // const mobile = theme.breakpoints.down('md');
  return (
    <StyledBox sx={{
      top: position === 'top' ? '0' : 'auto',
      bottom: position === 'bottom' ? '0' : 'auto',
      svg: {
        display: 'block',
        fill: theme => (theme.vars || theme).palette.background[fill],
        width: '100%',
        height,
      },
    }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" role="presentation">
        <Shape type={type} />
      </svg>
    </StyledBox>
  );
};

Separator.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.oneOf([
    'triangle-left-slant-up',
    'triangle-right-slant-up',
    'triangle-left-slant-down',
    'triangle-right-slant-down',
    'curve'
  ]),
  position: PropTypes.oneOf(['top', 'bottom']),
};

export default Separator;
